/**
 * In-memory store for the shell's device id, injected by the shell via
 * postMessage.
 *
 * The shell keeps the id in its own localStorage and sends it to the backend as
 * `x-device-id`. This app runs on another origin, so it cannot read that
 * localStorage — minting an id here would name a second device for the same
 * browser and defeat the point. The value has to arrive over the bridge.
 */

let _deviceId: string | null = null;

/** Called by CommunicationBridgeProvider when the shell sends a device id. */
export function setDeviceId(id: string) {
	_deviceId = id;
}

/** Returns the shell's device id, or null if not yet received. */
export function getDeviceId(): string | null {
	return _deviceId;
}
